export default __webpack_public_path__ + "static/media/conteudo_extra_09_21.f97fc21b.jpg";